define(function(require, exports, module) {
    'use strict';

    const BaseModel = require('common/base.model');
    const server = require('server');
    const $ = require('j');

    module.exports = BaseModel.extend({

        parse: function(response) {
            return response?.data || [];
        },

        sync: function(method, model, options) {
            if (method === 'read') {
                return $.when(this._loadTagsDetails(), this._loadRegulationStatus())
                    .done((tagResponse, regulationStatusResponse) => {
                        model.set('regStatus', regulationStatusResponse.data?.playerRegulationStatusHistory?.[0]?.code);
                        options.success?.(tagResponse);
                    })
                    .fail(options.error);
            }
        },

        _loadRegulationStatus: function() {
            return server.send({
                ID: 35691,
                description: 'Get User Regulation Status (from bonus counter)',
                responses: [35692, 35693],
            });
        },

        _loadTagsDetails: function() {
            return server.send({
                ID: 35547,
                description: 'Get Player Tags (from bonus counter)',
                responses: [35548, 35549]
            });
        }
    });
});
